/**
 * Hash Type Detector
 * 
 * Detects common cryptographic hash formats (MD5, SHA1, SHA256, SHA512).
 */

import { SEMANTIC_TYPES } from '@/detectors/semanticTypes';
import type { ISemanticType } from '@/interfaces/ISemanticType';
import type { ITypeDetector } from '@/interfaces/ITypeDetector';

// Common hash lengths in hex characters
const HASH_LENGTHS = {
  32: 'MD5',
  40: 'SHA1',
  64: 'SHA256',
  128: 'SHA512',
} as const;

export const HashDetector: ITypeDetector = {
  id: 'hash-detector',
  name: 'Hash Detector',
  priority: 85, // High priority for exact-length matches
  detectedType: SEMANTIC_TYPES.HASH,

  detect(input: string): ISemanticType | null {
    const trimmed = input.trim().toLowerCase();
    
    // Must be a known hash length
    if (!(trimmed.length in HASH_LENGTHS)) {
      return null;
    }

    // Must be valid hex characters only
    if (!/^[0-9a-f]+$/.test(trimmed)) {
      return null;
    }

    // Looks like a hash!
    return SEMANTIC_TYPES.HASH;
  },
};
